import React from 'react'
import Fade from 'react-reveal/Fade'
import { BiLogoLinkedin } from 'react-icons/bi'
import vinay from '../Image/vinay.webp'
import pooja from '../Image/pooja.webp'
import suman from '../Image/suman.webp'
import bhawna from '../Image/bhawna.webp'
import somya from '../Image/somya.webp'
import Akhilesh from '../Image/Akhilesh.webp'

function Company_staff() {
  const teamMembers = [
    {
      name: 'Suman',
      title: 'CEO & Founder',
      description:
        "Meet Suman Kumar, the passionate and driven CEO and Founder of Internselite. With his unwavering commitment to revolutionizing education, Suman brings a wealth of expertise and leadership to our team. Leveraging his extensive background in computer science and his deep understanding of the education landscape, Suman founded Internselite with a vision to bridge the gap between traditional learning and the demands of the digital age. Through innovative teaching methodologies and advanced technology, Suman is dedicated to empowering students with the essential skills and knowledge needed to thrive in today's rapidly evolving world. Under his guidance, Internselite strives to reshape the education experience and prepare students for success in the modern workforce.",
      imgSrc: suman,
      linkedIn:
        'https://www.linkedin.com/in/suman-kumar-4811841b8?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
      fadeDirection: 'left',
      alt: 'Suman - Director of InternsElite',
    },
    {
      name: 'Bhawna Singla',
      title: 'Founder & MD',
      description:
        "Meet Bhawna Singla, the passionate and driven Founder and Managing Director of Internselite. Armed with a Master of Business Administration (MBA) background, Bhawna combines her business acumen with a visionary approach to education. Her leadership at Internselite aims to transform the educational landscape by integrating business principles into the learning experience. With a commitment to preparing students for the dynamic challenges of the modern business world, Bhawna focuses on fostering a curriculum that not only imparts essential skills but also instills a strategic mindset. Under her guidance, Internselite strives to empower students with the knowledge and expertise required to excel in the competitive business environment. Bhawna Singla's dedication to merging business education with technological advancements positions Internselite as a pioneering force in shaping the business leaders of tomorrow.",
      imgSrc: bhawna,
      linkedIn:
        'https://www.linkedin.com/in/bhawna-singla-447a25166?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
      fadeDirection: 'right',
      alt: 'Bhawna - Director of InternsElite',
    },
    // {
    //   name: 'Vinay Singla',
    //   title: 'Admin & Head of Operations',
    //   description:
    //     "Meet Vinay Singla, the dedicated Admin and Head of Operations at Internselite. With a keen eye for detail and a passion for efficient organizational management, Vinay plays a crucial role in ensuring the smooth functioning of operations within the company. Drawing from his experience and expertise in administration, Vinay brings a structured and systematic approach to Internselite's daily operations. His responsibilities include overseeing logistics, managing resources, and maintaining a productive and collaborative work environment for the entire team.Vinay's commitment cellence is reflected in his meticulous attention to operational details, contributing to the overall success of Internselite. His role is pivotal in supporting the company's mission to revolutionize education through innovative methodologies and advanced technology. As Admin and Head of Operations, Vinay Singla plays a key role in the cohesive functioning of Internselite, ensuring that the organization operates seamlessly to deliver a high-quality educational experience to students.",
    //   imgSrc: vinay,
    //   linkedIn:
    //     'https://www.linkedin.com/in/vinay-45b101180?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    //   fadeDirection: 'left',
    //   alt: 'Vinay - Admin & Head of Operations at InternsElite',
    // },
  ]

  const additionalTeamMembers = [
    //{
    //  name: 'Pooja Choudhary',
    //  title: 'HR',
    //  imgSrc: pooja,
    //  linkedIn: 'https://www.linkedin.com/in/pooja-chaudhary-37406922b',
    //  alt: 'Pooja - HR at InternsElite',
    //},
    // {
    //   name: 'Somya Sharma',
    //   title: 'HR Executive',
    //   imgSrc: somya,
    //   linkedIn:
    //     'https://www.linkedin.com/in/somya-sharma-6728b0205?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    //   alt: 'Somya Sharma - BDE at InternsElite',
    // },
    //  {
    //    name: 'Akhilesh Mishra',
    //    title: 'Senior Manager',
    //    imgSrc: Akhilesh,
    //    linkedIn:
    //      'https://www.linkedin.com/in/akhilesh-kumar-mishra-925b95215?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    //    alt: 'Akhilesh Kumar Mishra - Senior Manager at InternsElite',
    //  },
    //{
      //name: 'Yash Kumar',
      //title: 'TL(Team Leader)',
      //imgSrc: yash,
      //linkedIn:
       // 'https://www.linkedin.com/in/yash-kumar-3967b527b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
      //alt: 'Yash - BDE at InternsElite',
    //},
  ]
  return (
    <div>
      {/* ------------------------------Mobile View--------------------------- */}
      <div className="bg-white d-sm-block d-md-none mb-3">
        <div className="container">
          <div className="text-center mobile_staff_component_text">
            <h2 className=" display-6">Meet Our Brilliant Team</h2>
            <p className="pb-3 mobile_staff_component_text_p">
              Our success is powered by a diverse team of talented individuals,
              each contributing unique expertise and passion to transform
              education through technology. Meet our exceptional team driving
              positive change.
            </p>
          </div>
          <div className="row d-flex justify-content-center">
            {teamMembers.map((member, index) => (
              <Fade
                key={index}
                {...{ [member.fadeDirection]: true }}
                className="container"
              >
                <div className="row py-2">
                  <div className="col-md-1"></div>
                  <div className="col-md-10 shadow rounded pt-3">
                    <div className="row py-2">
                      <div className="col-md-4">
                        <div className="d-flex justify-content-center">
                          <img
                            src={member.imgSrc}
                            alt={`${member.name} - ${member.title} at InternsElite`}
                            title={`${member.name} - ${member.title} at InternsElite`}
                            className="rounded-circle shadow-1-strong staff_card_img"
                            onContextMenu={(e) => e.preventDefault()}
                          />
                        </div>
                        <div className="text-center pt-3">
                          <h5 className="mb-2">{member.name}</h5>
                          <h6 className="mb-2">{member.title}</h6>
                          <div className="text-center pt-2">
                            <a
                              href={member.linkedIn}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <BiLogoLinkedin
                                size="40px"
                                color="#3d2e7c"
                                className="border rounded-pill p-2"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-8">
                        <div>
                          <span className="fas fa-quote-left"></span>
                        </div>
                        <div className="text-start pt-3">
                          <p className="Mobile_about_card_text">
                            {member.description}
                          </p>
                        </div>
                        <div className="text-end">
                          <span className="fas fa-quote-right px-3"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-1"></div>
                </div>
              </Fade>
            ))}
          </div>
          <Fade top>
            <div className="row mt-2">
              {additionalTeamMembers.map((member, index) => (
                <div key={index} className="col-6">
                  <div className="shadow rounded py-3 my-2">
                    <div className="d-flex justify-content-center">
                      <img
                        src={member.imgSrc}
                        alt={`${member.name} - ${member.title} at InternsElite`}
                        title={`${member.name} - ${member.title} at InternsElite`}
                        className="rounded-circle shadow-1-strong staff_card_img_bottom"
                        onContextMenu={(e) => e.preventDefault()}
                      />
                    </div>
                    <div className="text-center staf_card_text_bottom pt-3">
                      <h6 className="mb-2">{member.name}</h6>
                      <h6 className="mb-2">{member.title}</h6>
                    </div>
                    <div className="text-center pt-1">
                      <a
                        href={member.linkedIn}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <BiLogoLinkedin
                          size="40px"
                          color="#3d2e7c"
                          className="border rounded-pill p-2"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Fade>
        </div>
      </div>

      {/* ----------------------------Desktop View-------------------------------- */}
      <div className="d-none d-md-block mb-5 mt-4">
        <div className="container-fluid">
          <div className="container">
            <div className="text-center staff_component_text">
              <h2 className="display-6">Meet Our Brilliant Team</h2>
              <div className="px-5">
                <p className="py-2 px-5">
                  Our success is powered by a diverse team of talented
                  individuals, each contributing unique expertise and passion to
                  transform education through technology. Meet our exceptional
                  team driving positive change.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            {teamMembers.map((member, index) => (
              <Fade
                key={index}
                {...{ [member.fadeDirection]: true }}
                className="container mt-5"
              >
                <div className="d-flex justify-content-center mt-2">
                  <div className="row mb-2">
                    <div className="col-xl-1"></div>
                    <div className="col-xl-10 shadow rounded py-3">
                      <div className="row">
                        <div className="col-md-4 pt-2">
                          <div className="d-flex justify-content-center">
                            <img
                              src={member.imgSrc}
                              alt={`${member.name} - ${member.title} at InternsElite`}
                              title={`${member.name} - ${member.title} at InternsElite`}
                              className="rounded-circle shadow-1-strong staff_card_img"
                              onContextMenu={(e) => e.preventDefault()}
                            />
                          </div>
                          <div className="text-center pt-3">
                            <h5 className="mb-2">{member.name}</h5>
                            <h6 className="mb-2">{member.title}</h6>
                            <div className="text-center pt-2">
                              <a
                                href={member.linkedIn}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <BiLogoLinkedin
                                  size="40px"
                                  color="#3d2e7c"
                                  className="border rounded-pill p-2"
                                />
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-8">
                          <div className="text-start px-2 pt-4">
                            <p className="about_card_text">
                              {member.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-1"></div>
                  </div>
                </div>
              </Fade>
            ))}
          </div>
          <Fade top>
            <div className="row mt-5 px-5 d-flex justify-content-center">
              {additionalTeamMembers.map((member, index) => (
                <div key={index} className="col-md-2">
                  <div className="shadow rounded py-4">
                    <div className="d-flex justify-content-center">
                      <img
                        src={member.imgSrc}
                        alt={`${member.name} - ${member.title} at InternsElite`}
                        title={`${member.name} - ${member.title} at InternsElite`}
                        className="rounded-circle shadow-1-strong staff_card_img_bottom"
                        onContextMenu={(e) => e.preventDefault()}
                      />
                    </div>
                    <div className="text-center pt-3 staf_card_text_bottom">
                      <h5 className="mb-2">{member.name}</h5>
                      <h6 className="mb-2">{member.title}</h6>
                    </div>
                    <div className="text-center pt-3">
                      <a
                        href={member.linkedIn}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <BiLogoLinkedin
                          size="40px"
                          color="#3d2e7c"
                          className="border rounded-pill p-2"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Fade>
        </div>
      </div>
    </div>
  )
}

export default Company_staff
